// Cara Ldn desktop mega menu: hover / focus / click to open, Escape or click outside to close. Added by Claude, reversible.
if (!customElements.get('cara-desktop-menu')) {
  customElements.define('cara-desktop-menu', class extends HTMLElement {
    connectedCallback() {
      this.triggers = [...this.querySelectorAll('.cdd__trigger')];
      this.panels = [...this.querySelectorAll('.cdd__panel')];
      this.openTimer = null;
      this.closeTimer = null;
      const hoverable = matchMedia('(hover: hover)').matches;

      this.triggers.forEach((t) => {
        t.addEventListener('click', () => (t.getAttribute('aria-expanded') === 'true' ? this.close() : this.open(t.dataset.panel)));
        if (hoverable) {
          t.addEventListener('mouseenter', () => this.schedule(() => this.open(t.dataset.panel), this.current ? 0 : 120));
          t.addEventListener('mouseleave', () => this.schedule(() => this.close(), 220));
        }
        t.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown' && t.getAttribute('aria-expanded') === 'true') {
            e.preventDefault();
            this.querySelector(`#CddPanel-${t.dataset.panel} a`)?.focus();
          }
        });
      });
      this.panels.forEach((p) => {
        if (hoverable) {
          p.addEventListener('mouseenter', () => clearTimeout(this.timer));
          p.addEventListener('mouseleave', () => this.schedule(() => this.close(), 220));
        }
      });
      this.addEventListener('focusout', (e) => {
        if (!this.contains(e.relatedTarget)) this.close();
      });
      this.onKey = (e) => {
        if (e.key === 'Escape' && this.current) {
          const t = this.triggers.find((x) => x.dataset.panel === this.current);
          this.close();
          t?.focus();
        }
      };
      this.onDocClick = (e) => { if (!this.contains(e.target)) this.close(); };
      document.addEventListener('keydown', this.onKey);
      document.addEventListener('click', this.onDocClick);
      window.addEventListener('resize', () => this.current && this.position());
    }
    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
      document.removeEventListener('click', this.onDocClick);
    }
    schedule(fn, ms) {
      clearTimeout(this.timer);
      this.timer = setTimeout(fn, ms);
    }
    position() {
      const header = this.closest('header, .header, #header-component') || this;
      const bottom = Math.max(0, header.getBoundingClientRect().bottom);
      this.style.setProperty('--cdd-top', `${bottom}px`);
    }
    open(g) {
      clearTimeout(this.timer);
      this.current = g;
      this.position();
      this.triggers.forEach((t) => t.setAttribute('aria-expanded', String(t.dataset.panel === g)));
      this.panels.forEach((p) => (p.hidden = p.dataset.panel !== g));
    }
    close() {
      clearTimeout(this.timer);
      this.current = null;
      this.triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
      this.panels.forEach((p) => (p.hidden = true));
    }
  });
}
